<script setup>

import { ErrorMessage } from 'vee-validate';

const props = defineProps({
  label: {
    required: true,
  },
  autoCompleteType: {
    default: null,
  },
  id: {
    required: true,
  },
  isRequired: {
    default: false,
  },
  options: {
    default: [
      {
        id: 'none',
        label: 'None',
        value: 'none',
      },
    ],
    required: true,
  },
});

const model = defineModel();

</script>

<template>
  <div class="mt-6">
    <label
      :for="props.id"
      class="block text-sm font-medium text-primary"
    >{{ label }}</label>
    <div class="mt-3">
      <div
        :id="props.id"
        v-for="option in props.options"
        :key="option.id"
      >
        <input
          v-bind="$attrs"
          :id="option.id"
          v-model="model"
          type="radio"
          :value="option.value"
          :required="props.isRequired"
          :autocomplete="props.autoCompleteType"
          class="w-5 h-5 bg-transparent text-primary border-gray-300 focus:ring-1 focus:ring-highlight"
        >
        <label
          :for="props.id"
          class="ml-3 text-sm font-medium text-primary"
        >
          {{ option.label ? option.label : ( option.labelI18n ? $t(option.labelI18n) : "ERR: NO LABEL") }}
        </label>
      </div>

      <slot />
      <ErrorMessage
        :name="props.id"
        class="px-2 mt-2 text-sm text-red-400 dark:text-red-400"
        as="p"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
